import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "./footer.css"; // Optional: Add styles here
import logo from "../../assets/img/United_transparent_white.svg"; // Replace with your actual path
import insuredcar from "../../assets/img/insured-car.png"; // Replace with your actual path
import geoTrust from "../../assets/img/geotrust.svg"; // Corrected path for GeoTrust
import technologysolutions from "../../assets/img/technology_solutions.png";
import googlePlay from "../../assets/img/android.svg";
import appStore from "../../assets/img/iphone.svg";
import trustedSite from "../../assets/img/trusted_site.svg";
import { eventBus } from "../../eventBus";

const Footer = () => {
  const scrollToTop = (paddingTop) => {
    window.scrollTo({
      top: paddingTop,
      behavior: "smooth",
    });
  };

  const dispatch = useDispatch();

  const [containerStyle, setContainerStyle] = useState({ display: "flex" });
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 899px)"),
    };

    const updateDisplayStyle = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setContainerStyle({ display: "block" });
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setContainerStyle({ display: "block" });
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setContainerStyle({ display: "block" });
        setResponsiveStatus(true);
      } else {
        setContainerStyle({ display: "flex" });
        setResponsiveStatus(false);
      }
    };

    // Initial check
    updateDisplayStyle();

    // Listen to all media query changes
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateDisplayStyle)
    );

    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateDisplayStyle)
      );
    };
  }, []);

  return (
    <footer style={{ background: "none", marginTop: "60px" }}>
      <div
        className="shadow-lg"
        style={{
          maxWidth: "100%",
          width: "94%",
          // height: '390px',
          margin: responsiveStatus ? "-54px auto" : "-50px auto",
          backgroundColor: "#1272c7",
          color: "white",
          borderRadius: "18px",
          position: "relative",
          zIndex: 2,
          marginBottom: "-75px", // overlap effect
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        }}
      >
        <div className="row">
          <div
            className={`${
              responsiveStatus ? "mb-4 mt-3 col-12" : "col-md-3 mb-4 mt-3"
            }`}
          >
            <img
              src={require("../../assets/img/United_transparent_white.png")}
              alt="UAIC Logo"
              style={{
                width: "180px",
                marginBottom: "20px",
                marginLeft: "1em",
              }}
              className="logo-icon"
            />
            <br />
            <img
              src={insuredcar}
              className="footer-umbrella"
              alt="Umbrella Car Footer"
              style={{
                width: "350px",
                marginBottom: "20px",
                overflow: "hidden",
                position: "relative",
                left: "-135px",
                top: "2em",
                opacity: "0.5",
                clipPath: "inset(0 0 0 121px)",
                display: responsiveStatus ? "none" : "",
              }}
            />
          </div>
          <div
            className={`${responsiveStatus ? "col-12 mb-2" : "col-md-3 mb-4"}`}
            style={{
              display: responsiveStatus ? "flex" : "block",
              gap: responsiveStatus ? "40px" : "10px",
              justifyContent: "space-around",
            }}
          >
            {responsiveStatus && (
              <ul
                className={
                  responsiveStatus
                    ? "list-unstyled footer-list"
                    : "list-unstyled footer-list mt-3"
                }
              >
                <li className="fw-bold mb-2">UAIC HOME PAGE</li>
                <li>
                  <span>&#10095;</span>
                  {/* <a href="https://mypolicy.uaig.net/insurednew/"> */}
                  <a  tabIndex={0} onClick={() => eventBus.publish("openModal")}>
                    {" "}
                    Policyholder Portal
                  </a>
                </li>
                <li>
                  <span>&#10095;</span>
                  <a
                    onClick={() => eventBus.publish("openModal")}
                    style={{ cursor: "pointer" }}
                    tabIndex={0} 
                  >
                    {" "}
                    UAIC Agents Log In
                  </a>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/becomeAgent"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Become an Agent
                  </Link>
                </li>
                <li className="fw-bold mb-2">ABOUT UAIC</li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/aboutUs"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    About Us
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/site-map"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Site Map
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/site-requirements"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Site Requirements
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/site-requirements"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Accessibility Statement
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/privacy-policy"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/insurance"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Insurance
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/contact"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Contact
                  </Link>
                </li>
              </ul>
            )}
            {!responsiveStatus && (
              <ul
                className={
                  responsiveStatus
                    ? "list-unstyled footer-list"
                    : "list-unstyled footer-list mt-3"
                }
              >
                <li className="fw-bold mb-2">UAIC HOME PAGE</li>
                <li>
                  <span>&#10095;</span>
                  {/* <a href="https://mypolicy.uaig.net/insurednew/"> */}
                  <a
                    onClick={() => {
                      eventBus.publish("openModal");
                      eventBus.publish("customerModel");
                      dispatch({
                        type: "SET_LOGIN_PAGE_TO_DISPLAY",
                        payload: "CUSTOMER",
                      });
                    }}
                    tabIndex={0} 
                  >
                    {" "}
                    Policyholder Portal
                  </a>
                </li>
                <li>
                  <span>&#10095;</span>
                  <a
                    onClick={() => {
                      eventBus.publish("openModal");
                      dispatch({
                        type: "SET_LOGIN_PAGE_TO_DISPLAY",
                        payload: "AGENT",
                      });
                    }}
                    tabIndex={0} 
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    UAIC Agents Log In
                  </a>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/becomeAgent"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Become an Agent
                  </Link>
                </li>
              </ul>
            )}

            {responsiveStatus && (
              <ul className="list-unstyled footer-list">
                <li className="fw-bold mb-2">CAREERS</li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Careers",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Apply Online
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Benefits",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Benefits
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Diversity",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Diversity
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "FAQ",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    FAQ
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Job_Fairs",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Job Fairs
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Accounting",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Accounting
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Claims",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Claims Adjuster
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Corporate_&_Executive",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Corporate & Executive
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Information_Technology",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Information Technology
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Underwriting",
                      });
                      scrollToTop(100);
                    }}
                    to="/uaichome/careers"
                  >
                    {" "}
                    Underwriting
                  </Link>
                </li>
              </ul>
            )}
            {!responsiveStatus && (
              <ul className="list-unstyled footer-list">
                <li className="fw-bold mb-2">ABOUT UAIC</li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/aboutUs"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    About Us
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/site-map"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Site Map
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/site-requirements"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Site Requirements
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/accessibility"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Accessibility Statement
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/privacy-policy"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Privacy Policy
                  </Link>
                </li>
                   <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/terms-of-use"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Terms of Use
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/insurance"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Insurance
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    to="/uaichome/contact"
                    onClick={() => {
                      scrollToTop(0);
                    }}
                  >
                    {" "}
                    Contact
                  </Link>
                </li>
              </ul>
            )}
          </div>
          <div className={`${responsiveStatus ? "col-12" : "col-md-3 mb-4"}`}>
            {!responsiveStatus && (
              <ul className="list-unstyled footer-list mt-3">
                <li className="fw-bold mb-2">CAREERS</li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Careers",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "careers" },
                    }}
                  >
                    {" "}
                    Apply Online
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Benefits",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "benefits" },
                    }}
                  >
                    {" "}
                    Benefits
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Diversity",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "diversity" },
                    }}
                  >
                    {" "}
                    Diversity
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "FAQ",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "faq" },
                    }}
                  >
                    {" "}
                    FAQ
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Job_Fairs",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "jobFairs" },
                    }}
                  >
                    {" "}
                    Job Fairs
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Accounting",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "accounting" },
                    }}
                  >
                    {" "}
                    Accounting
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Claims",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "claims" },
                    }}
                  >
                    {" "}
                    Claims Adjuster
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Corporate_&_Executive",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "corporate" },
                    }}
                  >
                    {" "}
                    Corporate & Executive
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Information_Technology",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "informationTechnology" },
                    }}
                  >
                    {" "}
                    Information Technology
                  </Link>
                </li>
                <li>
                  <span>&#10095;</span>
                  <Link
                    style={{
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch({
                        type: "SET_SELECTED_CAREERS_TAB",
                        payload: "Underwriting",
                      });
                      scrollToTop(100);
                    }}
                    to={{
                      pathname: "/uaichome/careers",
                      state: { selectedTab: "underwriting" },
                    }}
                  >
                    {" "}
                    Underwriting
                  </Link>
                </li>
              </ul>
            )}
          </div>

          <div className={`${responsiveStatus ? "col-12" : "col-md-3 mb-4"}`}>
            <div
              style={{
                display: responsiveStatus ? "flex" : "block",
                gap: "20px",
                justifyContent: "space-around",
              }}
            >
              <div>
                <div className={responsiveStatus ? "mb-3" : "mb-3 mt-3"}>
                  <p
                    style={{
                      marginBottom: "0px",
                      fontSize: responsiveStatus ? "12px" : "18px",
                    }}
                  >
                    Stay connected with us
                  </p>
                  <span
                    style={{
                      fontSize: "1.5rem",
                      marginRight: "10px",
                      marginTop: "-10px",
                    }}
                  >
                    <a
                      style={{ color: "white" }}
                      href="https://www.instagram.com/united_automobile_insurance/?hl=en"
                      aria-label="Link to Instagram , inside of Footer "
                    >
                      <img
                        className="social-media-icons"
                        style={{
                          height: "20px",
                          width: "20px",
                          verticalAlign: responsiveStatus ? "middle" : "top",
                        }}
                        src={require("../../assets/img/instagram.png")}
                      />
                    </a>
                  </span>
                  <span style={{ fontSize: "1.5rem" }}>
                    <a
                      style={{ color: "white" }}
                      href="https://www.linkedin.com/company/unitedautomobileinsurance"
                      aria-label="Link to Linkedin , inside of Footer "
                    >
                      <img
                        style={{
                          height: responsiveStatus ? "15px" : "20px",
                          width: responsiveStatus ? "15px" : "20px",
                          verticalAlign: responsiveStatus ? "middle" : "top",
                        }}
                        src={require("../../assets/img/linkedin.png")}
                        className="social-media-icons"
                      />
                    </a>
                  </span>
                </div>
              </div>
              <div style={{ marginTop: "-1em" }}>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.levelaccess.com/a/uaic/?utm_source=uaichomepage&utm_medium=iconlarge&utm_term=eachannelpage&utm_content=header&utm_campaign=uaic"
                >
                  <img
                    src={technologysolutions}
                    alt="technologysolutions"
                    style={{
                      height: "44px",
                      borderRadius: "6px",
                      padding: "2px 8px",
                      width: "150px",
                    }}
                    className="geo-trust mt-2"
                  />
                </a>
                <div
                  className="mb-2"
                  style={{
                    fontSize: responsiveStatus ? "0.6rem" : "0.7rem",
                    marginTop: "2em",
                  }}
                >
                  Managing your policy just got easier.
                  <br />
                  Download our app today
                </div>
                <div className="mb-3" style={containerStyle}>
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.phonegap.uaic&hl=en"
                    rel="noreferrer"
                  >
                    <img
                      src={googlePlay}
                      alt="Google Play"
                      style={{
                        height: responsiveStatus ? "auto" : "auto",
                        width: responsiveStatus ? "auto" : "auto",
                        marginRight: "10px",
                      }}
                      className="app-icons"
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://apps.apple.com/us/app/united-automobile-insurance/id868152074"
                    rel="noreferrer"
                  >
                    <img
                      src={appStore}
                      alt="App Store"
                      style={{
                        height: responsiveStatus ? "auto" : "auto",
                        width: responsiveStatus ? "auto" : "auto",
                      }}
                      className="app-icons"
                    />
                  </a>
                </div>
              </div>
            </div>

            {!responsiveStatus && (
              <>
                <div className="mb-2">Powered by</div>
                <div className="d-block justify-content-center">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://seal.digicert.com/seals/popup/?tag=7E0EEXXz&url=www.uaig.net&lang=en"
                  >
                    <img
                      src={geoTrust}
                      alt="GeoTrust"
                      style={{
                        height: "40px",
                        background: "white",
                        borderRadius: "6px",
                        padding: "2px 8px",
                      }}
                      className="geo-trust"
                    />
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${
          responsiveStatus
            ? "container-fluid px-3 mt-1"
            : "container-fluid px-5 mt-2"
        }`}
        style={{
          backgroundColor: "#01224F",
          position: "relative",
          zIndex: 1,
          minHeight: responsiveStatus ? "180px" : "120px",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          paddingBottom: responsiveStatus ? "1.5rem" : "0.5rem",
        }}
      >
        {responsiveStatus && (
          <div style={{ fontSize: "12px" }}>
            Copyright © {new Date().getFullYear()} United Automobile Insurance
            Company
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
          {!responsiveStatus && (
            <div style={{ fontSize: "12px" }}>
              Copyright © {new Date().getFullYear()} United Automobile Insurance
              Company
            </div>
          )}
          <div>
            {responsiveStatus && (
              <>
                <div className="mb-2" style={{ fontSize: "12px" }}>
                  Powered by
                </div>
                <div className="d-block justify-content-center">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://seal.digicert.com/seals/popup/?tag=7E0EEXXz&url=www.uaig.net&lang=en"
                  >
                    <img
                      src={geoTrust}
                      alt="GeoTrust"
                      style={{
                        height: "26px",
                        background: "white",
                        borderRadius: "6px",
                        padding: "2px 8px",
                      }}
                    />
                  </a>
                  <br />
                 
                </div>
              </>
            )}
          </div>
          {/* <div>
            <img
              src={trustedSite}
              alt="TrustedSite"
              style={{ height: "35px", width: "100px" }}
            />
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
